<template>
  <div class="reg-container">
    <MessageBox
      :visible="showMessage"
      :message="messageText"
      :type="messageType"
    />
    <el-dialog
      v-model="showQrcodeDialog"
      title="注册成功"
      width="400px"
      center
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="qrcode-dialog-content">
        <p class="success-message">注册成功！请等待管理员审核（预计2-3个工作日）</p>
        <p class="qrcode-tip">扫描下方二维码加入用户群，获取帮助：</p>
        <div class="qrcode-container">
          <img
            v-if="qrcode.image_type === 'upload'"
            :src="`https://abc.atmcorr.com/api/uploads//qrcode/${encodeURIComponent(qrcode.image_path)}`"
            alt="入群二维码"
            class="qrcode-image"
          />
          <img
            v-else-if="qrcode.image_type === 'url'"
            :src="qrcode.image_url"
            alt="入群二维码"
            class="qrcode-image"
          />
          <div v-else class="qrcode-loading">
            <el-icon class="is-loading"><Loading /></el-icon>
            <span>加载二维码中...</span>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="goToHome">返回首页</el-button>
        </div>
      </template>
    </el-dialog>
    <div class="reg-card">
      <h2 class="reg-title">用户注册</h2>
      
      <!-- 注册表单 -->
      <form 
        @submit.prevent="handleSubmit"
        class="reg-form"
      >
        <div class="form-section">
          <div class="input-group">
            <label>姓名</label>
            <input
              v-model="form.name"
              type="text"
              :class="{ 'input-error': errors.name }"
              placeholder="请输入真实姓名"
            >
            <p v-if="errors.name" class="error-msg">{{ errors.name }}</p>
          </div>

          <div class="input-group">
            <label>单位类型</label>
            <select
              v-model="form.profession"
              :class="{ 'input-error': errors.profession }"
              class="w-full p-2 border rounded-md"
            >
              <option value="">请选择单位类型</option>
              <option value="科研院所">科研院所</option>
              <option value="院校">院校</option>
              <option value="航天部门">航天部门</option>
              <option value="商业公司">商业公司</option>
              <option value="行业部委">行业部委</option>
              <option value="地方用户">地方用户</option>
            </select>
            <p v-if="errors.profession" class="error-msg">{{ errors.profession }}</p>
          </div>

          <div class="input-group">
            <label>单位名称</label>
            <input
              v-model="form.institution_name"
              type="text"
              :class="{ 'input-error': errors.institution_name }"
              placeholder="请输入具体单位名称，如：中国科学院遥感地球所"
            >
            <p v-if="errors.institution_name" class="error-msg">{{ errors.institution_name }}</p>
          </div>

          <div class="input-group">
            <label>个人学历</label>
            <select
              v-model="form.organization"
              :class="{ 'input-error': errors.organization }"
              class="w-full p-2 border rounded-md"
            >
              <option value="">请选择个人学历</option>
              <option value="博士">博士</option>
              <option value="硕士">硕士</option>
              <option value="学士">学士</option>
              <option value="专科">专科</option>
              <option value="在读研究生">在读研究生</option>
              <option value="在读本科生">在读本科生</option>
              <option value="在读专科生">在读专科生</option>
            </select>
            <p v-if="errors.organization" class="error-msg">{{ errors.organization }}</p>
          </div>

          <div class="input-group">
            <label>使用目的</label>
            <select
              v-model="form.purpose"
              :class="{ 'input-error': errors.purpose }"
              class="w-full p-2 border rounded-md"
            >
              <option value="">请选择使用目的</option>
              <option v-for="option in purposeOptions" :key="option" :value="option">{{ option }}</option>
            </select>
            <p v-if="errors.purpose" class="error-msg">{{ errors.purpose }}</p>
            <textarea
              v-if="form.purpose === '其他'"
              v-model="form.purposeOther"
              :class="{ 'input-error': errors.purposeOther }"
              placeholder="请详细描述使用本系统的目的"
              rows="3"
              class="w-full p-2 border rounded-md"
              style="margin-top: 10px;"
            ></textarea>
            <p v-if="errors.purposeOther" class="error-msg">{{ errors.purposeOther }}</p>
          </div>

          <div class="input-group">
            <label>手机号码</label>
            <input
              v-model="form.phone"
              type="tel"
              :class="{ 'input-error': errors.phone }"
              placeholder="请输入11位手机号码"
            >
            <p v-if="errors.phone" class="error-msg">{{ errors.phone }}</p>
          </div>

          <div class="input-group">
            <label>微信号</label>
            <input
              v-model="form.wechat_name"
              type="text"
              :class="{ 'input-error': errors.wechat_name }"
              placeholder="请输入微信号"
            >
            <p v-if="errors.wechat_name" class="error-msg">{{ errors.wechat_name }}</p>
          </div>

          <div class="input-group">
            <label>电子邮箱</label>
            <input
              v-model="form.email"
              type="email"
              :class="{ 'input-error': errors.email }"
              placeholder="请输入常用邮箱"
            >
            <p v-if="errors.email" class="error-msg">{{ errors.email }}</p>
          </div>

          <div class="input-group">
            <label>验证码</label>
            <div class="verification-code-group">
              <input
                v-model="form.verificationCode"
                type="text"
                :class="{ 'input-error': errors.verificationCode }"
                placeholder="请输入验证码"
                class="verification-input"
              >
              <button 
                type="button"
                @click="handleSendCode"
                :disabled="isSendingCode || !form.email || countdown > 0"
                class="send-code-btn"
              >
                {{ isSendingCode ? '发送中...' : countdown > 0 ? `${countdown}秒后重试` : '获取邮箱验证码' }}
              </button>
            </div>
            <p v-if="errors.verificationCode" class="error-msg">{{ errors.verificationCode }}</p>
          </div>

          <div class="input-group">
            <label>密码</label>
            <input
              v-model="form.password"
              type="password"
              :class="{ 'input-error': errors.password }"
              placeholder="请输入密码（8-20位，含大小写字母和数字）"
            >
            <p v-if="errors.password" class="error-msg">{{ errors.password }}</p>
          </div>
          <div class="input-group">
            <label>确认密码</label>
            <input
              v-model="form.confirmPassword"
              type="password"
              :class="{ 'input-error': errors.confirmPassword }"
              placeholder="请再次输入密码"
            >
            <p v-if="errors.confirmPassword" class="error-msg">{{ errors.confirmPassword }}</p>
          </div>
        </div>

        <button 
          type="submit"
          class="submit-btn"
          :disabled="isSubmitting">
          <span v-if="isSubmitting" class="loading-spinner"></span>
          {{ isSubmitting ? '提交中...' : '立即注册' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import MessageBox from '@/components/MessageBox.vue'
import { Loading } from '@element-plus/icons-vue'

export default {
  components: {
    MessageBox,
    Loading
  },
  data() {
    return {
      form: {
        name: '',
        profession: '',
        organization: '',
        purpose: '',
        purposeOther: '', // 新增自定义目的
        phone: '',
        email: '',
        password: '',
        confirmPassword: '', // 新增确认密码
        verificationCode: '',
        institution_name: '',
        wechat_name: ''
      },
      errors: {
        name: '',
        profession: '',
        organization: '',
        purpose: '',
        purposeOther: '', // 新增自定义目的错误
        phone: '',
        email: '',
        password: '',
        confirmPassword: '', // 新增确认密码错误
        verificationCode: '',
        institution_name: '',
        wechat_name: ''
      },
      purposeOptions: [
        '学术研究',
        '项目合作',
        '产品试用',
        '技术交流',
        '其他'
      ],
      isSubmitting: false,
      isSendingCode: false,
      countdown: 0,
      timer: null,
      showMessage: false,
      messageText: '',
      messageType: 'error',
      showQrcodeDialog: false,
      qrcode: {
        image_type: '',
        image_path: '',
        image_url: ''
      }
    }
  },
  methods: {
    showMessageBox(message, type = 'error') {
      this.messageText = message
      this.messageType = type
      this.showMessage = true
      setTimeout(() => {
        this.showMessage = false
      }, 3000)
    },

    startCountdown() {
      this.countdown = 60
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(this.timer)
          this.timer = null
        }
      }, 1000)
    },

    validateForm() {
      this.errors = {
        name: '',
        profession: '',
        organization: '',
        purpose: '',
        purposeOther: '',
        phone: '',
        email: '',
        password: '',
        confirmPassword: '',
        verificationCode: '',
        institution_name: '',
        wechat_name: ''
      }

      let isValid = true

      if (!this.form.name.trim()) {
        this.errors.name = '请输入姓名'
        isValid = false
      }

      if (!this.form.profession) {
        this.errors.profession = '请选择单位类型'
        isValid = false
      }

      if (!this.form.institution_name.trim()) {
        this.errors.institution_name = '请输入单位名称'
        isValid = false
      }

      if (!this.form.organization) {
        this.errors.organization = '请选择个人学历'
        isValid = false
      }

      if (!this.form.purpose) {
        this.errors.purpose = '请选择使用目的'
        isValid = false
      } else if (this.form.purpose === '其他') {
        if (!this.form.purposeOther.trim()) {
          this.errors.purposeOther = '请输入使用目的'
          isValid = false
        } else if (this.form.purposeOther.length < 20) {
          this.errors.purposeOther = '使用目的需不少于20字'
          isValid = false
        }
      }

      if (this.form.purpose !== '其他' && this.form.purpose && this.form.purpose.length < 2) {
        this.errors.purpose = '请选择有效的使用目的'
        isValid = false
      }

      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.errors.phone = '手机号格式不正确'
        isValid = false
      }

      if (!this.form.wechat_name.trim()) {
        this.errors.wechat_name = '请输入微信昵称'
        isValid = false
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email)) {
        this.errors.email = '邮箱格式不正确'
        isValid = false
      }

      if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[\w\W]{8,20}$/.test(this.form.password)) {
        this.errors.password = '密码需8-20位，包含大小写字母和数字'
        isValid = false
      }

      if (!this.form.confirmPassword) {
        this.errors.confirmPassword = '请再次输入密码'
        isValid = false
      } else if (this.form.password !== this.form.confirmPassword) {
        this.errors.confirmPassword = '两次输入的密码不一致'
        isValid = false
      }

      if (!this.form.verificationCode.trim()) {
        this.errors.verificationCode = '请输入验证码'
        isValid = false
      }

      return isValid
    },

    async handleSendCode() {
      if (!this.form.email) {
        this.showMessageBox('请先输入邮箱')
        return
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email)) {
        this.showMessageBox('邮箱格式不正确')
        return
      }

      if (this.countdown > 0) {
        return
      }

      this.isSendingCode = true
      try {
        await this.$axios.post('/auth/send-code', { email: this.form.email })
        this.showMessageBox('验证码已发送，请查收邮箱', 'success')
        this.startCountdown()
      } catch (error) {
        if (error.response) {
          this.showMessageBox(error.response.data.message || '发送验证码失败')
        } else {
          this.showMessageBox('发送验证码失败，请稍后重试')
        }
      } finally {
        this.isSendingCode = false
      }
    },

    async fetchQrcode() {
      try {
        const res = await this.$axios.get('/auth/qrcode')
        if (res && res.id) {
          this.qrcode = {
            id: res.id,
            image_type: res.image_type,
            image_path: res.image_path,
            image_url: res.image_url
          }
        }
      } catch (err) {
        console.error('获取二维码失败:', err)
        this.showMessageBox('获取二维码失败，请联系管理员', 'warning')
      }
    },

    handleImageError(e) {
      console.error('图片加载失败:', e)
      this.showMessageBox('二维码图片加载失败，请联系管理员', 'warning')
    },

    handleImageLoad(e) {
      console.log('图片加载成功:', e)
    },

    async handleSubmit() {
      if (!this.validateForm()) return

      this.isSubmitting = true
      try {
        const registerData = {
          name: this.form.name,
          email: this.form.email,
          phone: this.form.phone,
          password: this.form.password,
          code: this.form.verificationCode,
          profession: this.form.profession,
          organization: this.form.organization,
          purpose: this.form.purpose === '其他' ? this.form.purposeOther : this.form.purpose,
          institution_name: this.form.institution_name,
          wechat_name: this.form.wechat_name
        }

        const response = await this.$axios.post('/auth/verify-code', registerData)
        
        // 显示二维码弹窗
        this.showQrcodeDialog = true

        // 重置表单
        this.form = {
          name: '',
          profession: '',
          organization: '',
          purpose: '',
          purposeOther: '',
          phone: '',
          email: '',
          password: '',
          confirmPassword: '',
          verificationCode: '',
          institution_name: '',
          wechat_name: ''
        }
      } catch (error) {
        if (error.response) {
          console.error('注册错误详情:', error.response.data)
          this.showMessageBox(error.response.data.message || `注册失败：${error.response.status} ${error.response.statusText}`)
        } else if (error.request) {
          console.error('无响应:', error.request)
          this.showMessageBox('服务器未响应，请检查网络连接')
        } else {
          console.error('请求配置错误:', error.message)
          this.showMessageBox('请求配置错误：' + error.message)
        }
      } finally {
        this.isSubmitting = false
      }
    },

    goToHome() {
      this.showQrcodeDialog = false
      this.$router.push('/')
    }
  },
  mounted() {
    // 页面加载时获取二维码
    this.fetchQrcode()
  },
  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>

<style scoped>
.reg-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  position: relative;
  overflow: hidden;
  font-family: 'Orbitron', sans-serif;
}

/* 量子粒子效果 */
.reg-container::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(circle at 50% 50%, rgba(0, 180, 255, 0.1) 0%, transparent 50%),
    linear-gradient(45deg, rgba(0, 247, 255, 0.05) 25%, transparent 25%),
    linear-gradient(-45deg, rgba(255, 0, 255, 0.05) 25%, transparent 25%);
  background-size: 100% 100%, 60px 60px, 60px 60px;
  background-position: center center, 0 0, 0 0;
  pointer-events: none;
  z-index: 0;
}

.reg-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 440px;
  padding: 2.5rem;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.reg-title {
  text-align: center;
  color: #1a1a2e;
  font-size: 1.75rem;
  font-weight: 600;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.reg-form {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1.5rem;
  font-size: 0.875rem;
}

.input-group {
  margin-bottom: 1.5rem;
  position: relative;
}

.input-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: #4a5568;
  font-size: 0.875rem;
  font-weight: 500;
}

.input-group label::after {
  content: '*';
  color: #e53e3e;
  margin-left: 0.3rem;
}

.input-group input,
.input-group select,
.input-group textarea {
  width: 100%;
  padding: 0.875rem 1rem;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #2d3748;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}

.input-group input:focus,
.input-group select:focus,
.input-group textarea:focus {
  outline: none;
  border-color: #4299e1;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
  background: #ffffff;
}

.input-group input::placeholder {
  color: #a0aec0;
}

.input-error {
  border-color: #e53e3e !important;
  background: #fff5f5 !important;
}

.error-msg {
  color: #e53e3e;
  font-size: 0.75rem;
  margin-top: 0.25rem;
}

.submit-btn {
  width: 100%;
  padding: 0.875rem;
  background: linear-gradient(135deg, #4299e1 0%, #3182ce 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(66, 153, 225, 0.2);
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading-spinner {
  display: inline-block;
  width: 1.2rem;
  height: 1.2rem;
  border: 3px solid rgba(255,255,255,0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.verification-code-group {
  display: flex;
  gap: 1rem;
}

.verification-input {
  flex: 1;
}

.send-code-btn {
  padding: 0.875rem 1.5rem;
  background: #4299e1;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
  min-width: 120px;
}

.send-code-btn:hover:not(:disabled) {
  background: #3182ce;
  transform: translateY(-1px);
}

.send-code-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background: #a0aec0;
}

.qrcode-dialog-content {
  text-align: center;
  padding: 20px 0;
}

.success-message {
  color: #67c23a;
  font-size: 16px;
  margin-bottom: 20px;
}

.qrcode-tip {
  color: #606266;
  margin-bottom: 20px;
}

.qrcode-container {
  margin: 20px auto;
  max-width: 200px;
}

.qrcode-image {
  width: 200px;
  height: auto;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.qrcode-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  color: #909399;
}

.dialog-footer {
  text-align: center;
  padding-top: 20px;
}
</style>
